<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'gestoesDeAulas',
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Plano Mensal Infantil
        </h1>
      </v-col>
    </v-row>

    <div v-if="turmaSemCircuito">
      <v-alert
        type="warning"
        border="left"
        colored-border
        elevation="2"
        icon="mdi-alert-circle-outline"
        dense
        class="mt-4"
      >
        Não é possível enviar planos: não há circuito cadastrado para esta turma.
      </v-alert>
    </div>

    <div v-else>
      <v-row>
        <v-col cols="12" v-if="gestaoDeAula">
          <v-card color="green lighten-1" outlined>
            <v-col cols="10">
              <v-card-text>
                <h4>Turma: {{ gestaoDeAula.turma.descricao }}</h4>
                <h4>Componente Curricular: {{ gestaoDeAula.disciplina.descricao }}</h4>
                <h4>
                  Professor:
                  {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[carregando...]" }}
                </h4>
              </v-card-text>
            </v-col>

            <v-col cols="2">
              <v-btn
                x-small
                class="ml-1 white--text"
                color="teal darken-2"
                @click="() => verHistoricoPlanos()"
              >
                <span>Histórico do lançamento de planos</span>
              </v-btn>
            </v-col>
            <v-col cols="2">
              <v-btn
                large
                class="ml-1 white--text"
                color="teal darken-4"
                @click="() => baixarDocumentoPlanoCircuitoInfantil()"
              >
                <v-icon class="mr-2">fa fa-download</v-icon>
                <span>Documento Auxiliar</span>
              </v-btn>
            </v-col>
          </v-card>
        </v-col>

        <v-col cols="12" class="pt-2">
          <template>
            <v-toolbar>
              <v-tabs dark background-color="primary" v-model="tabIndexEtapas" grow>
                <v-tab
                  v-for="(value, desc) in etapas"
                  :key="parseInt(value, 10)"
                  @click="() => loadData(parseInt(value, 10))"
                >
                  <v-badge v-if="form.etapa_id === parseInt(value, 10)" color="success">
                    {{ desc }}
                  </v-badge>
                  <div v-else>{{ desc }}</div>
                </v-tab>
              </v-tabs>
            </v-toolbar>
          </template>
        </v-col>
      </v-row>
      <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
        <form
          @submit.prevent="handleSubmit(createOrUpdate)"
          v-if="loadPlano"
          :disabled="submittingForm"
          class="container"
        >
          <v-row>
            <div
              v-if="
                etapaBloqueada ||
                (currentEtapa?.roles != '[]' &&
                  etapaBloqueadaParaGrupo &&
                  user.roleName != 'super-admin')
              "
              class="overlay"
            >
              <div class="blocked-div pa-10 text-center">
                <div v-if="etapaBloqueada">
                  <v-icon size="50" class="mb-5">lock</v-icon>
                  <h2>Lançamento Bloqueado</h2>
                  <p class="mt-3" v-if="currentEtapa">
                    O período de lançamento de planos para este mês é de
                    {{ validarData(currentEtapa.periodo_inicial) }}
                    a
                    {{ validarData(currentEtapa.periodo_final) }}.
                  </p>
                </div>
                <div
                  v-if="
                    currentEtapa?.roles != '[]' &&
                    etapaBloqueadaParaGrupo &&
                    user.roleName != 'super-admin'
                  "
                >
                  <template v-if="etapaBloqueada">
                    <v-divider class="my-4"></v-divider>
                  </template>

                  <v-icon size="50" class="mb-5">security</v-icon>
                  <div class="mb-2">
                    <h2 class="mb-2">ATENÇÃO</h2>
                    Somente os usuários dos seguintes grupos poderão realizar alterações nesta
                    etapa:
                    <p>
                      <strong>
                        {{
                          currentEtapa?.roles ? JSON.parse(currentEtapa?.roles).join(", ") : ""
                        }}.</strong
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <v-col>
              <div v-text="'Ciclo dessa Etapa'" class="text-overline font-weight-bold mt-5"></div>
              <v-alert
                text
                border="left"
                color="deep-green"
                icon="calendar_month"
                class="text-caption"
              >
                <span class="font-weight-bold"
                  >De {{ validarData(currentEtapa.periodo_inicial) }}</span
                >
                <span class="font-weight-bold">
                  à {{ validarData(currentEtapa.periodo_final) }}</span
                >
                <e-chips-extensao-etapa :etapa="currentEtapa" contexto="planos" />
              </v-alert>
              <ValidationProvider
                name="TEMÁTICA TRABALHADA"
                rules="required|max:2000"
                v-slot="{ errors }"
              >
                <e-label>TEMÁTICA TRABALHADA</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="form.unidades_tematicas"
                  :error-messages="errors"
                  :maxlength="2000"
                  :counter="true"
                >
                  <template v-slot:counter>
                    {{ (form.unidades_tematicas || "").length }}/2000
                  </template>
                </v-textarea>
              </ValidationProvider>

              <ValidationProvider
                name="CAMPOS DE EXPERIÊNCIA"
                rules="required|max:2000"
                v-slot="{ errors }"
              >
                <e-label>CAMPOS DE EXPERIÊNCIA </e-label>
                <v-textarea
                  solo
                  dense
                  v-model="form.campos_de_experiencia_texto"
                  :error-messages="errors"
                  :maxlength="2000"
                  :counter="true"
                >
                  <template v-slot:counter>
                    {{ (form.campos_de_experiencia_texto || "").length }}/2000
                  </template>
                </v-textarea>
              </ValidationProvider>

              <!-- <ValidationProvider name="CAMPOS DE EXPERIÉNCIA" rules="required" v-slot="{ errors }">
                <e-label>CAMPOS DE EXPERIÊNCIA</e-label>

                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                    v-for="(item, index) in $constants.planoBimestralCampoDeExperiencia"
                    :key="index"
                  >
                    <v-checkbox
                      :label="item.label"
                      :value="item.label"
                      v-model="form.campos_de_experiencia"
                      multiple
                      :error-messages="errors"
                    />
                  </v-col>
                </v-row>
              </ValidationProvider> -->
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <ValidationProvider name="PROJETO" rules="required|max:2000" v-slot="{ errors }">
                <e-label>PROJETO</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="form.projeto"
                  :error-messages="errors"
                  :maxlength="2000"
                  :counter="true"
                >
                  <template v-slot:counter>{{ (form.projeto || "").length }}/2000</template>
                </v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-col cols="12">
            <v-row>
              <v-btn
                color="primary"
                :disabled="
                  submittingForm ||
                  etapaBloqueada ||
                  (currentEtapa?.roles != '[]' &&
                    etapaBloqueadaParaGrupo &&
                    user.roleName != 'super-admin')
                "
                :loading="submittingForm"
                type="submit"
              >
                Enviar Dados
              </v-btn>
              <v-btn
                color="success"
                class="ml-3"
                @click="exportDialog = true"
                :disabled="!planoPreenchido || !planoRegistrado"
                >Exportar plano</v-btn
              >
            </v-row>
          </v-col>
        </form>
      </ValidationObserver>
      <v-row justify="center">
        <v-dialog v-model="exportDialog" persistent max-width="800px">
          <v-card>
            <v-card-title class="primary">
              <span style="color: #fff" class="text-h5">Exportar Plano</span>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-container>
                <ValidationObserver v-slot="{ handleSubmit }">
                  <form
                    v-if="show"
                    @submit.prevent="handleSubmit(exportarPlano)"
                    :disabled="submittingForm"
                  >
                    <v-row>
                      <v-col class="pt-4 pb-0" cols="12">
                        <e-label class="font-weight-medium">Turma</e-label>
                        <p class="font-weight-regular">
                          <v-select
                            :items="turmas"
                            item-text="turma.descricao"
                            item-value="turma.id"
                            return-object
                            label="Selecione o campo abaixo"
                            v-model="turmaSelecionada"
                            @change="(item) => setGestao(item)"
                          ></v-select>
                        </p>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <e-label class="font-weight-medium">TEMÁTICA TRABALHADA</e-label>
                        <p class="font-weight-regular">
                          {{ form.unidades_tematicas }}
                        </p>
                      </v-col>
                      <v-col cols="12">
                        <e-label class="font-weight-medium">CAMPOS DE EXPERIÊNCIA</e-label>
                        <p class="font-weight-regular">
                          {{ form.campos_de_experiencia_texto }}
                        </p>
                      </v-col>
                      <!-- <v-col cols="12">
                        <e-label class="font-weight-medium">CAMPOS DE EXPERIÊNCIA</e-label>

                        <ul class="font-weight-regular pl-4">
                          <li v-for="(campo, index) in form.campos_de_experiencia" :key="index">
                            {{ campo }}
                          </li>
                        </ul>
                      </v-col> -->
                      <v-col cols="12">
                        <e-label class="font-weight-medium">PROJETO</e-label>
                        <p class="font-weight-regular">
                          {{ form.projeto }}
                        </p>
                      </v-col>
                    </v-row>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn style="color: #fff" class="red darken-1" @click="exportDialog = false">
                        Fechar
                      </v-btn>
                      <v-btn
                        :disabled="submittingForm || !turmaSelecionada"
                        :loading="submittingForm"
                        type="submit"
                        style="color: #fff"
                        class="green darken-1"
                        >Salvar</v-btn
                      >
                    </v-card-actions>
                  </form>
                </ValidationObserver>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
      <e-drawer-planos-lancados
        v-model="openDrawer"
        :gestao_id="parseInt($route.params.gestaoDeAulaId, 10)"
        :disciplina_id="parseInt(gestaoDeAula.disciplina.id, 10)"
        :etapa="etapaSelecionada"
      />
    </div>
  </main-template>
</template>

<script>
import { extend } from "vee-validate";
import { mapGetters } from "vuex";
import ELabel from "../../components/ELabel.vue";
import { dateFormatParam } from "../../plugins/filters";

extend("arrayNotEmpty", {
  validate: (value) => Array.isArray(value) && value.length > 0,
  message: "É necessário selecionar pelo menos um item",
});

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    gestaoDeAulaId: {
      type: [String, Number],
      require: true,
    },
  },
  async mounted() {
    await this.loadData();
  },
  data() {
    return {
      habilidade: null,
      experiencia_: null,
      modalDeletarObjetivo: false,
      mensagem: "",
      carregandoHabilidades: false,
      showMessage: false,
      experiencia: [],
      objetivosAprendizagem: [],
      dialog: false,
      search: "",
      submittingForm: false,
      form: {
        etapa_id: null,
        campos_de_experiencia: [],
        recursos: [],
      },
      openDrawer: false,
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
      },
      loadPlano: true,
      etapas: [],
      tabIndexEtapas: null,
      exportDialog: false,
      show: true,
      turmas: [],
      turmaSelecionada: null,
      formExportarPlano: {
        etapa_id: null,
      },
      etapaBloqueada: false,
      etapaBloqueadaParaGrupo: true,
      arrayEtapasDisponiveis: [],
      currentEtapa: null,
    };
  },
  computed: {
    ...mapGetters("Auth", ["user"]),
    planoPreenchido() {
      return (
        this.form.unidades_tematicas && this.form.campos_de_experiencia_texto && this.form.projeto
        // this.form.campos_de_experiencia &&
        // this.form.campos_de_experiencia.length > 0 &&
        // this.form.projeto.length > 0
      );
    },
    planoRegistrado() {
      return !!this.form.id;
    },
    turmaSemCircuito() {
      return this.etapas.length === 0;
    },
    etapaSelecionada() {
      const entry = Object.entries(this.etapas).find(([, val]) => val === this.form.etapa_id);
      if (!entry) return null;
      const [descricao, id] = entry;
      return { descricao, id };
    },
  },
  methods: {
    async deletarExperiencia(experiencia) {
      const pesquisa = experiencia.toString();
      const index = this.experiencia.findIndex((e) => e === pesquisa);
      this.experiencia.splice(index, 1);
    },
    async verHistoricoPlanos() {
      this.openDrawer = !this.openDrawer;
    },
    async createOrUpdate() {
      this.$loaderService.open("Carregando dados...");

      try {
        const { gestaoDeAulaId } = this.$route.params;
        this.form.disciplina_id = this.gestaoDeAula.disciplina.id;
        this.form.instrutorDisciplinaTurma_id = gestaoDeAulaId;
        this.form.experiencia = this.experiencia.map((e) => e);
        this.form.objeto_aprendizagem = this.objeto_aprendizagem.map((o) => o.id);
        await this.$services.planosCircuitoInfantilService.createOrUpdate(this.form);

        this.$toast.success("Plano bimestral salvo com sucesso!");
        await this.loadData(this.form.etapa_id);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async loadData(etapa_id) {
      if (this.$refs.observer) {
        await this.$refs.observer.reset();
      }
      this.submittingForm = false;
      const { gestaoDeAulaId } = this.$route.params;
      try {
        this.$loaderService.open("Carregando dados...");

        if (etapa_id) {
          this.form.etapa_id = etapa_id;
        } else {
          this.gestaoDeAula = await this.$services.gestoesDeAulasService.visualizarTurmaGestao(
            gestaoDeAulaId
          );
          this.form.etapa_id = this.gestaoDeAula.turma.circuito?.etapas[0].id;
          const gestoes = await this.$services.gestoesDeAulasService.listarGestoesProfessor(
            this.gestaoDeAula
          );
          this.turmas = gestoes.filter((gestao) => gestao.turma.id !== this.gestaoDeAula.turma.id);
        }

        const response = await this.$services.planosCircuitoInfantilService.planoCircuito(
          gestaoDeAulaId,
          this.form.etapa_id
        );
        this.circuito_nota_id = this.gestaoDeAula.turma.circuito_nota_id;
        this.etapas = response.etapas ?? [];

        if (response.plano !== "") {
          this.preencherPlano(response);
        } else {
          this.limparPlano();
        }

        this.verificarSituacaoEtapa();

        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    preencherPlano(response) {
      this.form = {
        ...response.plano,
        campos_de_experiencia: response.plano.campos_de_experiencia
          ? JSON.parse(response.plano.campos_de_experiencia)
          : [],
        recursos: response.plano.recursos ? JSON.parse(response.plano.recursos) : [],
      };
      this.objeto_aprendizagem = response.habilidades;
      this.experiencia = response.plano.experiencia;
    },

    limparPlano() {
      this.form = {
        etapa_id: this.form.etapa_id,
        campos_de_experiencia: [],
        recursos: [],
      };
      this.objeto_aprendizagem = [];
      this.experiencia = [];
    },
    async baixarDocumentoPlanoCircuitoInfantil() {
      try {
        this.$loaderService.open("Carregando dados...");

        await this.$services.planosCircuitoInfantilService.baixarDocumentoPlanoCircuitoInfantil(
          parseInt(this.$route.params.gestaoDeAulaId, 10),
          parseInt(this.form.etapa_id, 10)
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    setGestao(item) {
      this.export_gestao = item.id;
    },
    async exportarPlano() {
      this.$loaderService.open("Exportando plano...");

      try {
        const { bimestre } = this.form;

        this.formExportarPlano.instrutorDisciplinaTurma_id = this.export_gestao;
        this.formExportarPlano.disciplina_id = this.gestaoDeAula.disciplina.id;
        this.formExportarPlano.etapa_id = this.form.etapa_id;

        this.formExportarPlano.unidades_tematicas = this.form.unidades_tematicas;
        this.formExportarPlano.campos_de_experiencia = this.form.campos_de_experiencia;
        this.formExportarPlano.projeto = this.form.projeto;

        this.formExportarPlano.experiencia = this.experiencia.map((e) => e);
        this.formExportarPlano.objeto_aprendizagem = this.objeto_aprendizagem.map((o) => o.id);

        this.formExportarPlano.abordagens_estrategias_didaticas =
          this.form.abordagens_estrategias_didaticas;
        this.formExportarPlano.recursos = this.form.recursos;

        this.formExportarPlano.campos_de_experiencia_texto = this.form.campos_de_experiencia_texto;

        await this.$services.planosCircuitoInfantilService.createOrUpdate(this.formExportarPlano);

        this.$toast.success("Plano exportado com sucesso!");

        this.dialog = false;
        this.exportDialog = false;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },

    async verificarSituacaoEtapa() {
      try {
        const response = await this.$services.etapasService.syncAllEtapasDisponiveis(
          this.circuito_nota_id,
          this.$route.params.gestaoDeAulaId,
          "planos"
        );

        this.arrayEtapasDisponiveis = response.disponiveis;

        const etapaCompleta = response.etapas.find((e) => e.id === this.form.etapa_id);
        if (etapaCompleta) {
          this.currentEtapa = etapaCompleta;
        }

        if (this.arrayEtapasDisponiveis?.includes(this.currentEtapa?.id)) {
          this.etapaBloqueada = false;
        } else {
          this.etapaBloqueada = true;
        }

        // verificar se grupo tem permissao para acesso
        const rolesPermitidos = this.currentEtapa?.roles;
        let rolesArray = [];

        if (typeof rolesPermitidos === "string") {
          try {
            rolesArray = JSON.parse(rolesPermitidos);
          } catch (e) {
            rolesArray = [];
          }
        } else if (Array.isArray(rolesPermitidos)) {
          rolesArray = rolesPermitidos;
        }

        if (rolesArray.includes(this.user.roleName)) {
          this.etapaBloqueadaParaGrupo = false;
        } else {
          this.etapaBloqueadaParaGrupo = true;
        }
      } catch (error) {
        this.$handleError(error);
      }
    },
    validarData(data) {
      if (!data) return "";
      return dateFormatParam(data, "d/m/y");
    },
  },
};
</script>

<style scoped>
.container {
  position: relative;
  border-radius: 8px;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5); /* para adicionar um fundo semi-transparente */
  border-radius: 8px;
}

.blocked-div {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  background-color: white;
  border-radius: 8px;
}

.blocked-div h2 {
  text-align: center;
}
</style>
